import { render, staticRenderFns } from "./cell-organization-members.vue?vue&type=template&id=2658b1a4&scoped=true"
import script from "./cell-organization-members.ts?vue&type=script&lang=ts&external"
export * from "./cell-organization-members.ts?vue&type=script&lang=ts&external"
import style0 from "./cell-organization-members.vue?vue&type=style&index=0&id=2658b1a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2658b1a4",
  null
  
)

export default component.exports